var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],staticClass:"gl-shrink-0",attrs:{"icon":"spam","title":_vm.title,"aria-label":_vm.__('Hidden'),"variant":"warning"}})
}
var staticRenderFns = []

export { render, staticRenderFns }